import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { FormattedMessage, useIntl } from "react-intl";
import Link from "./link";

const query = graphql`
  query {
    allContentfulDestination(
      filter: { partner: { ne: true }, category: { order: { eq: 1 } } }
      sort: { fields: order }
    ) {
      nodes {
        node_locale
        contentful_id
        title
        slug
        inProject
        category {
          title
        }
      }
    }

    allContentfulHome {
      nodes {
        node_locale
        burgerMenuLinks {
          link
          id
          target
          title
        }
        footerMenu {
          link
          id
          target
          title
        }
      }
    }
  }
`;

const FullNav = ({ handleClick }) => {
  const { allContentfulDestination, allContentfulHome } = useStaticQuery(query);
  const { locale, formatMessage } = useIntl();
  const isActiveLocale = ({ node_locale }) => node_locale === locale;

  const destinations = allContentfulDestination.nodes.filter(isActiveLocale);

  const { burgerMenuLinks } = allContentfulHome.nodes.find(
    (item) => item.node_locale === locale
  );

  const { footerMenu } = allContentfulHome.nodes.find(
    (item) => item.node_locale === locale
  );

  return (
    <nav className="navigation" aria-label={formatMessage({ id: "fullNav" })}>
      <ul // eslint-disable-line
        role="list"
      >
        <li>
          <p>{destinations.find(isActiveLocale).category.title}</p>
          <ul // eslint-disable-line
            role="list"
          >
            {destinations.map(({ contentful_id: id, title, slug }) => (
              <li key={id}>
                <Link href={`/destinations/${slug}`} onClick={handleClick}>
                  {title}
                </Link>
              </li>
            ))}
          </ul>
        </li>
        <li>
          <p>Gravel Up</p>
          <ul role="list">
            {burgerMenuLinks.map((item) => (
              <li key={item.id}>
                <Link
                  href={`${item.link}`}
                  target={item.target === true ? "_blank" : "_self"}
                  onClick={handleClick && handleClick}
                >
                  {item.title}
                </Link>
              </li>
            ))}
          </ul>
        </li>
        <li>
          <p>
            <FormattedMessage
              id="ourSuggestions"
              defaultMessage={"Nos suggestions"}
            />
          </p>
          <ul role="list">
            {footerMenu.map((item) => (
              <li key={item.id}>
                <Link
                  href={`${item.link}`}
                  target={item.target === true ? "_blank" : "_self"}
                  onClick={handleClick && handleClick}
                >
                  {item.title}
                </Link>
              </li>
            ))}
          </ul>
        </li>
      </ul>
    </nav>
  );
};

export default FullNav;
